/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { call, put, takeLatest, all, takeEvery } from "redux-saga/effects";
import * as connectorAction from "./actions";
import {
  FetchConnectors,
  FetchAConnector,
  CreateConnector,
  UpdateConnector,
  ValidateConnector,
  DeleteConnector,
  UpdateLinkConnector,
  ValidateNameConnector,
  FetchAConnectorConfigStats,
} from "./services";
import { VALIDATION_ERROR } from "../../app/Constants/Constants";

// worker saga: makes the api call when watcher saga sees the action
export function* fetchConnectorSaga(action) {
  /* istanbul ignore next */
  try {
    const response = yield call(FetchConnectors, action.payload);

    const connectors =
      // eslint-disable-next-line no-nested-ternary
      response.data || {}
        ? response.data.data
        : response.data
        ? response.data
        : {};
    connectors.list = connectors.results;
    delete connectors.results;
    yield put(connectorAction.FetchConnectorsSuccess(connectors));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(connectorAction.FetchConnectorsFailed(error));
  }
}
export function* loadMoreConnectorSaga(action) {
  const { payload } = action;
  try {
    const response = yield call(FetchConnectors, payload);
    yield put(
      connectorAction.LoadMoreConnectorsSuccess(response.data.data.results),
    );
  } catch (error) {
    yield put(connectorAction.LoadMoreConnectorsFailed(error));
  }
}
export function* fetchAConnectorSaga(action) {
  try {
    const response = yield call(FetchAConnector, action.payload);
    if (response && response.data) {
      yield put(connectorAction.FetchAConnectorSuccess(response.data[0]));
    } else {
      yield put(
        connectorAction.FetchAConnectorFailed({
          message: "Something went wrong. Please try later",
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(connectorAction.FetchAConnectorFailed(error));
  }
}
// This is no longer used......
// export function* changeConnectorStatusSaga(action) {
//   try {
//     const response = yield call(ChangeConnectorStatus, action.payload);
//     if (response.data === true || !response.data) {
//       // TODO since no response from server...
//       yield put(connectorAction.ChangeConnectorStatusSuccess("success"));
//     } else {
//       yield put(
//         connectorAction.ChangeConnectorStatusFailed({
//           message: "Something went wrong. Please try later"
//         })
//       );
//     }
//   } catch (error) {
//     // dispatch a failure action to the store with the error
//     yield put(connectorAction.ChangeConnectorStatusFailed(error));
//   }
// }
export function* createConnectorSaga(action) {
  try {
    const response = yield call(CreateConnector, action.payload);
    if (response && response.data && response.data.success) {
      yield put(connectorAction.CreateConnectorSuccess(response.data));
    } else {
      yield put(connectorAction.CreateConnectorFailed(response.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    const message =
      error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : error;
    yield put(connectorAction.CreateConnectorFailed(message));
  }
}
export function* updateConnectorSaga(action) {
  try {
    const response = yield call(UpdateConnector, action.payload);
    if (response && response.data && response.data.success) {
      yield put(connectorAction.UpdateConnectorSuccess(response));
    } else {
      const message =
        response?.data?.message === VALIDATION_ERROR
          ? response.data.errors[0]
          : response?.data?.message
          ? response.data.message
          : null;
      yield put(connectorAction.UpdateConnectorFailed(message));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    const message =
      error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : error;
    yield put(connectorAction.UpdateConnectorFailed(message));
  }
}
export function* fetchConnectorOfDatapipeSaga(action) {
  try {
    const response = yield call(FetchAConnector, action.payload);
    /* istanbul ignore next */
    if (response.data && response.data.length) {
      yield put(
        connectorAction.FetchConnectorOfDatapipeSuccess(response.data[0]),
      );
    } else {
      /* istanbul ignore next */
      yield put(
        connectorAction.FetchConnectorOfDatapipeFail({
          message: "Something went wrong. Please try later",
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(connectorAction.FetchConnectorOfDatapipeFail(error));
  }
}
export function* ValidateConnectorSaga(action) {
  try {
    const response = yield call(ValidateConnector, action.payload);
    /* istanbul ignore else */
    if (response.data && (response.data.valid || !response.data.canValidate)) {
      yield put(connectorAction.ValidateConnectorsSuccess(response.data));
    } else {
      yield put(connectorAction.ValidateConnectorsFail(response.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(connectorAction.ValidateConnectorsFail(error));
  }
}
export function* deleteConnectorSaga(action) {
  try {
    const response = yield call(DeleteConnector, action.payload);
    if (response.data) {
      yield put(connectorAction.DeleteConnectorSuccess(response));
    } else {
      yield put(connectorAction.DeleteConnectorFailed(response.data));
    }
  } catch (error) {
    yield put(connectorAction.DeleteConnectorFailed(error));
  }
}
export function* fetchAConnectorDelSaga(action) {
  try {
    const response = yield call(FetchAConnector, action.payload);
    if (response && response.data) {
      yield put(connectorAction.FetchAConnectorDelSuccess(response.data[0]));
    } else {
      yield put(
        connectorAction.FetchAConnectorDelFailed({
          message: "Something went wrong. Please try later",
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(connectorAction.FetchAConnectorDelFailed(error));
  }
}

export function* updateLInkConnectorSaga(action) {
  try {
    const response = yield call(UpdateLinkConnector, action.payload);
    if (response && response.data && response.data.success) {
      yield put(connectorAction.UpdateLinkConnectorSuccess("success"));
      yield put(
        connectorAction.UpdateConnectorList(
          action.payload.connector,
          action.payload.projectName,
        ),
      );
    } else {
      yield put(connectorAction.UpdateLinkConnectorFailed(response.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    const message =
      error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : error;
    yield put(connectorAction.UpdateLinkConnectorFailed(message));
  }
}

export function* validateNameConnectorSaga(action) {
  try {
    const response = yield call(ValidateNameConnector, action.payload);
    /* istanbul ignore else */
    if (response.data) {
      yield put(connectorAction.ValidateConnectorNameSuccess(response.data));
    } else {
      yield put(connectorAction.ValidateConnectorNameFail(response.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(connectorAction.ValidateConnectorNameFail(error));
  }
}

export function* fetchAConnectorConfigStatsSaga(action) {
  try {
    const response = yield call(FetchAConnectorConfigStats, action.payload);
    if (response && response.data && response.data.success) {
      yield put(
        connectorAction.FetchAConnectorConfigStatsSuccess(response.data),
      );
    } else {
      yield put(
        connectorAction.FetchAConnectorConfigStatsFailed(response.data),
      );
    }
  } catch (error) {
    yield put(connectorAction.FetchAConnectorConfigStatsFailed(error));
  }
}
// watcher saga: watches for actions dispatched to the store, starts worker saga
export function* connectorWatcher() {
  yield all([
    takeLatest(connectorAction.types.FETCH_CONNECTORS, fetchConnectorSaga),
    takeEvery(
      connectorAction.types.LOAD_MORE_CONNECTORS,
      loadMoreConnectorSaga,
    ),
    takeLatest(connectorAction.types.FETCH_A_CONNECTOR, fetchAConnectorSaga),
    // commented since no longer need to update status alone
    // takeLatest(
    //   connectorAction.types.CHANGE_CONNECTOR_STATUS,
    //   changeConnectorStatusSaga
    // ),
    takeLatest(connectorAction.types.CREATE_CONNECTOR, createConnectorSaga),
    takeLatest(connectorAction.types.UPDATE_CONNECTOR, updateConnectorSaga),
    takeLatest(connectorAction.types.VALIDATE_CONNECTOR, ValidateConnectorSaga),
    takeEvery(
      connectorAction.types.FETCH_CONNECTOR_OF_DATAPIPE,
      fetchConnectorOfDatapipeSaga,
    ),
    takeLatest(connectorAction.types.DELETE_CONNECTOR, deleteConnectorSaga),
    takeLatest(
      connectorAction.types.FETCH_A_CONNECTOR_DEL,
      fetchAConnectorDelSaga,
    ),
    takeEvery(
      connectorAction.types.UPDATE_LINK_CONNECTOR,
      updateLInkConnectorSaga,
    ),
    takeEvery(
      connectorAction.types.VALIDATE_CONNECTOR_NAME,
      validateNameConnectorSaga,
    ),
    takeLatest(
      connectorAction.types.FETCH_A_CONNECTOR_CONFIG_STATS,
      fetchAConnectorConfigStatsSaga,
    ),
  ]);
}
